import { useState } from 'react';
import { Tab } from '@headlessui/react';
import {
  DocumentCheckIcon,
  AcademicCapIcon,
  ComputerDesktopIcon,
  BuildingOfficeIcon,
  PlayCircleIcon,
  ClockIcon,
} from '@heroicons/react/24/outline';
import clsx from 'clsx';
import CCRPMaturity from './tabs/CCRPMaturity';
import TrainingAwareness from './tabs/TrainingAwareness';
import TechnicalReadiness from './tabs/TechnicalReadiness';
import Governance from './tabs/Governance';
import SimulationResults from './tabs/SimulationResults';
import IncidentHistory from './tabs/IncidentHistory';

const tabs = [
  { id: 'ccrp', name: 'CCRP Maturity', icon: DocumentCheckIcon },
  { id: 'training', name: 'Training & Awareness', icon: AcademicCapIcon },
  { id: 'technical', name: 'Technical Readiness', icon: ComputerDesktopIcon },
  { id: 'governance', name: 'Governance', icon: BuildingOfficeIcon },
  { id: 'simulation', name: 'Simulation Results', icon: PlayCircleIcon },
  { id: 'incidents', name: 'Incident History', icon: ClockIcon },
];

export default function ReadinessAssessment() {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">Readiness Assessment</h2>

      <Tab.Group selectedIndex={selectedTab} onChange={setSelectedTab}>
        <Tab.List className="flex space-x-4 border-b border-gray-200">
          {tabs.map((tab) => (
            <Tab
              key={tab.id}
              className={({ selected }) =>
                clsx(
                  'flex items-center space-x-2 py-2 px-4 text-sm font-medium border-b-2 outline-none',
                  selected
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                )
              }
            >
              <tab.icon className="h-5 w-5" />
              <span>{tab.name}</span>
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels>
          <Tab.Panel><CCRPMaturity /></Tab.Panel>
          <Tab.Panel><TrainingAwareness /></Tab.Panel>
          <Tab.Panel><TechnicalReadiness /></Tab.Panel>
          <Tab.Panel><Governance /></Tab.Panel>
          <Tab.Panel><SimulationResults /></Tab.Panel>
          <Tab.Panel><IncidentHistory /></Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
}